var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function () {
  document.getElementById("swym-email-friend-form").addEventListener(
    "submit",
    function (e) {
      e.preventDefault();
      const submitButton = this.querySelector('.form-submit[type="submit"]');

      if (this.classList.contains("loading")) return;

      submitButton.setAttribute("aria-disabled", true);
      submitButton.classList.add("loading");
      this.querySelector(".loading-overlay__spinner").classList.remove(
        "hidden"
      );

      document.getElementById("swym-email-friend-button").disabled = true;
      var that = this;

      window._swat.sendEmailWishList(
        function (r) {
          console.log("Email sent!");
          document.getElementById("swym-email-friend-button").disabled = false;
          let eAlert = document.getElementById("email-alert");
          eAlert.classList.toggle("hidden");
          setTimeout(() => {
            eAlert.classList.toggle("hidden");
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            that
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          }, 2000);
          that.reset();
        },
        document.getElementById("swym-email-friend-input").value,
        document.getElementById("swym-from-friend-input").value,
        document.getElementById("swym-email-note-input").value
      );
    },
    false
  );

  document
    .getElementById("action-add-products")
    .addEventListener("click", (event) => {
      event.preventDefault();

      var checkboxCart = document.getElementsByClassName("wishlist-checkbox");
      var checkboxesChecked = [];
      for (var i = 0; i < checkboxCart.length; i++) {
        if (checkboxCart[i].checked === true) {
          if (checkboxCart[i].value) {
            var itemData = { quantity: 1, id: checkboxCart[i].value.trim() };
            checkboxesChecked.push(itemData);
          }
        }
      }

      if (checkboxesChecked.length <= 0) {
        alert("PLEASE SELECT A PRODUCT TO CONTINUE");
        return false;
      }

      var data = {};
      data.items = checkboxesChecked;

      fetch("/cart/add.js", {
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With":
            "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
        },
        method: "POST",
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          /* we have JSON */
          // console.log(json)
          if (json.status == 422) {
            alert(
              json.description
                .replace("is already sold out.", "is not available.")
                .replace("The product", "The requested quantity for product")
            );
            return;
          }
          window.mini_cart.updateCart(true);
        })
        .catch(function (err) {
          /* uh oh, we have error. */
          console.error(err);
        });
    });

  var _products = {};
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(function () {
    _swat.fetch(function (products) {
      // render products - array of objects with same structure as productData
      // {{Insert your rendering function}}

      var waitForJQuery = setInterval(function () {
        if (typeof $ != "undefined") {
          renderProducts(products);

          clearInterval(waitForJQuery);
        }
      }, 10);

      // products count - products.length
      // {{Insert your count update}}
      var countHTMLElem = document.getElementById("wishlist-count-span");
      _swat.renderWishlistCount(countHTMLElem, function (cnt, elem) {
        // successful rendering
        console.log("Wishlist count", cnt);
      });
    }, _swat.retailerSettings.RelayUI.Title);
  });

  function renderProducts(products) {
    // Handle zero products
    if (products.length == 0) {
      $("#wishlist-actions").hide();
      $("#wishlist-count").hide();
      $("#zero-wishlist").show();
    } else {
      $("#wishlist-actions").show();
      $("#wishlist-count").show();
      $("#zero-wishlist").hide();
    }
    var productsHtml = products.map(function (product) {
      // store local reference
      _products[product.epi] = product;
      return renderProduct(product);
    });
    $("#wishlist-product-list").html(productsHtml);
    replaceProductTitleQuotes(
      document.querySelectorAll("#wishlist-product-list [data-product-title]")
    );
    $("#wishlist-product-list .custom-wishlist-delete").click(function (e) {
      e.preventDefault();
      let parent = $(e.currentTarget).closest(".grid__item");
      let productEventId = $(this).data()["productEventid"];
      let itemData = $(this).data().itemMap.split(",");

      removeProductFromList($(parent).data().listId, {
        epi: itemData[0],
        empi: itemData[1],
        du: itemData[2],
      });

      _swat.deleteEvent(function callback() {
        // Successfully deleted, re-render page
        $(e.currentTarget).closest(".grid__item").remove();
        if ($("#wishlist-product-list .grid__item").length < 1) {
          location.reload();
        }
      }, productEventId);
    });
    $("#wishlist-product-list .custom-wishlist-add-to-cart").click(function (
      e
    ) {
      e.preventDefault();
      var productId = $(this).data()["productId"];
      var productData = _products[productId];
      _swat.replayAddToCart(productData, productData.epi, function () {
        // Successfully added, open cart
        _swat.openCartPage();
      });
    });

    products.map(function (product) {
      updateProductVariantInfo(product["du"], product["epi"]);
    });
  }

  function removeProductFromList(listId, listItemMap) {
    _swat.deleteFromList(
      listId,
      listItemMap,
      function (deletedListItem) {
        // successfully deleted list item
        console.log(`Item deleted`, deletedListItem);
      },
      function (xhrObj) {
        // something went wrong
        console.log(`Error deleting item from list: `, xhrObj);
      }
    );
  }

  function renderProduct(product) {
    // Using Mustache with different tags
    Mustache.tags = ["<%", "%>"];
    var tmpl = loadTemplate("product-item-tmpl");
    var r = Mustache.render(tmpl, transformProduct(product));
    Mustache.tags = ["{{", "}}"];
    return r;
  }

  function updateProductVariantInfo(url, variantId) {
    fetch(url + "?view=json")
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        let finalVariant = false;

        for (i = 0; i < json.variants.length; i++) {
          let variant = json.variants[i];
          if (variant["id"] == variantId) {
            finalVariant = variant;
            break;
          }
        }
        if (finalVariant) {
          if (finalVariant.qty < 1 && finalVariant.policy == "deny") {
            var els = document.getElementsByClassName("product--" + variantId);
            for (var i = 0; i < els.length; i++) {
              els[i].classList.add("product--soldout");
            }
          }
        }
      });
  }

  function transformProduct(product) {
    // To use Shopify's default formatter -
    // But warning - Some themes throw an unknown format exception,
    // build custom formatter in that case
    const money_format = Shopify.money_format || "${{amount}}";

    if (Shopify.formatMoney && Shopify.money_format && product["pr"]) {
      product["formated_pr"] = Shopify.formatMoney(
        product["pr"].toFixed(2),
        money_format
      );
      if (product["op"]) {
        product["formated_op"] = Shopify.formatMoney(
          product["op"].toFixed(2),
          money_format
        );
      }
    }

    product["stock_message"] = false;
    product["stock_class"] = "product--" + product["epi"];

    product["isInCart"] =
      window._swat.platform.isInDeviceCart(product.epi) ||
      product.et == window._swat.EventTypes.addToCart;
    product["pr"] = product["pr"].toFixed(2);
    if (product["op"]) {
      product["op"] = product["op"].toFixed(2);
    }
    var size = "";
    var variant = "";

    if (!(typeof product.variants == "undefined")) {
      size = product.variants
        .substring(
          product.variants.indexOf("/ ") + 1,
          product.variants.lastIndexOf('":')
        )
        .replace('"', "")
        .trim();

      variant = product.variants
        .substring(
          product.variants.indexOf(":") + 1,
          product.variants.lastIndexOf("}")
        )
        .replace('"', "")
        .trim();
    }

    product["size"] = "";
    product["variant"] = false;

    if (size.trim() !== "" && size.indexOf("Default") == -1) {
      product["size"] = "SIZE: " + size;
    }

    if (variant.trim() !== "") {
      product["variant"] = variant;
    }

    product.currency = _swat.currency; // use currency in case you want to render in the template
    return product;
  }

  function loadTemplate(templateId) {
    var template = document.getElementById(templateId);
    if (!template) {
      SwymUtils.warn("Error cannot find the template #" + templateId);
      return false;
    }

    var templateHtml = template.innerHTML.trim();
    Mustache.parse(templateHtml);
    return templateHtml;
  }
})();
